import Headline, { type Props } from "./Headline";

export default function H4({size = "lg", ...props}:Props) {
  return <Headline tag="h4" size={size} {...props}/>;
}